import React from "react";
import CustomLoadingIcon from "../generic/CustomLoadingIcon";
import { Dropdown, Spin, Table } from "antd";
import { DownCircleFilled, SettingOutlined } from "@ant-design/icons";

function ResultTableComponent({
  data,
  columns,
  clickTableRow,
  expandable,
  rowClassName,
  loading,
  grouped,
}) {
  const updatedColumns = columns.map((column) => {
    if (column.key === "action") {
      return {
        ...column,
        render: (_, record) => {
          if (record.isGroupHeader) return null;
          return (
            <Dropdown
              menu={{
                items: [
                  {
                    key: "1",
                    label: "View",
                    onClick: () =>
                      clickTableRow(record.resultSummaryKey, record),
                  },
                ],
              }}
              overlayClassName="table-row-actions-dropdown"
            >
              <a className="table-more-options">
                Options <DownCircleFilled />
              </a>
            </Dropdown>
          );
        },
      };
    }
    return column;
  });

  const resolveRowClassName = (record) => {
    if (record.isGroupHeader) return "result-summary-group-row";
    return rowClassName || "";
  };

  const resolveRowKey = (record) =>
    record.isGroupHeader ? record.key : record.resultSummaryKey;

  const treeExpandable = grouped
    ? {
        defaultExpandAllRows: false,
        indentSize: 24,
        expandRowByClick: true,
        ...expandable,
      }
    : expandable;

  return (
    // arc-library-table carries the shared zebra striping, row height and hairline
    // borders the Task and Document libraries use, so the tables read as one product.
    <div
      className={`arc-library-table${
        grouped ? " result-summary-grouped-table" : ""
      }`}
    >
      <Table
        dataSource={data}
        columns={updatedColumns}
        loading={{ spinning: loading, indicator: <CustomLoadingIcon /> }}
        pagination={{
          defaultPageSize: grouped ? 50 : 20,
          showSizeChanger: true,
          pageSizeOptions: grouped
            ? ["10", "20", "50", "100"]
            : ["5", "10", "20", "30"],
        }}
        expandable={treeExpandable}
        rowKey={resolveRowKey}
        rowClassName={resolveRowClassName}
      ></Table>
    </div>
  );
}

export default ResultTableComponent;
